module.exports = __webpack_public_path__ + "media/images/common/sns/tiktok-dbce5915ca85357f3bcb928e9999550c.png";